export default __webpack_public_path__ + "static/media/CTP_Light_EN.37579e6c.svg";